import React from "react"
import PropTypes from "prop-types"
import {useSelector} from "react-redux"

import "./summary/summary.scss"
import DifferentInvoiceAdressInput from "./documents/differentInvoiceAdressInput"
import YourOrder from "./summary/your-order"
import Payment from "./summary/payment"
import {getTotal} from "../../utils/calculs"
import HelpUr from "../../components/help/help"

const Summary = ({prevTab}) => {
    const { ticket, options } = useSelector(({registrationReducer}) => registrationReducer)
    const { user } = useSelector(({registrationReducer}) => registrationReducer)
    return (
        <div className={"content summary"}>
            <p className={"important-infos"}>Résumé et paiement</p>

            <div className={"row"}>
                <div className={"col-lg-6"}>
                    <YourOrder ticket={ticket} options={options} total={getTotal(ticket, options, user)}/>
                </div>
                <div className={"col-lg-6"}>
                    <Payment total={getTotal(ticket, options, user)}/>
                </div>
            </div>
            <div className={"content-footer"}>                       
                <button className={"sr-btn-next btn btn-secondary"} onClick={prevTab}>Précédent</button>
                    <small className={"help"}><HelpUr/></small>
            </div>
        </div>
    )
}

Summary.propTypes = {
    prevTab: PropTypes.func.isRequired,
}

export default Summary
